import * as React from 'react';

import { EBedroomsCount } from '../../../../../../../json_query';
import { DropdownField } from '../../../components/dropdownField';

export interface IBedroomsProps {
  value: EBedroomsCount;
  onChange(count: EBedroomsCount): void;
}

interface IBedrooms {
  label: string;
  value: EBedroomsCount;
}

const VALUES: IBedrooms[] = [
  { value: EBedroomsCount.Any, label: 'Неважно' },
  { value: EBedroomsCount.One, label: '1+' },
  { value: EBedroomsCount.Two, label: '2+' },
  { value: EBedroomsCount.Three, label: '3+' },
  { value: EBedroomsCount.Four, label: '4+' },
  { value: EBedroomsCount.Five, label: '5+' },
  { value: EBedroomsCount.Six, label: '6+' },
  { value: EBedroomsCount.Seven, label: '7+' },
];

export const Bedrooms: React.StatelessComponent<IBedroomsProps> = ({ value, onChange }) => (
  <DropdownField value={value} onValueChange={onChange} values={VALUES} />
);
